<div class="nothing-found">
  <mat-icon class="search-glass">search_off</mat-icon>
  <h3>{{ message }}</h3>
</div>